import CardHoverInfo from '../CardHoverInfo';
import TarotCard from '../TarotCard';
import './CelticCrossSpread.css';

/** The Celtic Cross layout: the dealt cards in their positions. */
function CelticCrossSpread({ spread, cards, revealed, onReveal }) {
  return (
    <div className="celtic-cross-layout">
      {cards.map((card, index) => {
        const position = spread.positions[index];
        const isRevealed = revealed.includes(index);

        return (
          <div
            key={index}
            className={`card-position position-${index + 1} ${isRevealed ? 'revealed' : ''}`}
            onClick={() => onReveal(index)}
          >
            <div className="position-label">
              <span className="position-number">{position.id}</span>
              <span className="position-name">{position.name}</span>
            </div>
            <CardHoverInfo card={card}>
              <TarotCard card={card} isRevealed={isRevealed} />
            </CardHoverInfo>
          </div>
        );
      })}
    </div>
  );
}

export default CelticCrossSpread;
